// @flow
import * as React from 'react'
import styled from 'styled-components'
import {translate} from 'react-i18next'
import {
  Banner,
  Link,
  Section,
  Traits,
  Trait,
  styles
} from 'tutellus-ui'

import {Page} from './Page'

const HowItWork = styled(Section)`
    & ${Traits} {
      @media ${styles.media.tablet} {
        grid-template-columns: repeat(2,1fr);
      }
      @media ${styles.media.laptop} {
        grid-template-columns: repeat(4,1fr);
      }
    }
`
HowItWork.displayName = 'HowItWork'

export const Gifts = translate('gifts')(({t}) =>
  <Page>
    <Banner title={t('title')}
      background_url={t('background_url')}>
      <small>{ t('why') }</small>
      <p>{ t('description') }</p>
      <Link button primary
        href={t('urls:courses')}
      >
        { t('cta') }
      </Link>
    </Banner>
    <HowItWork title={t('how_it_works')}>
      <Traits>{
        JSON.parse(t('feats')).map(feat =>
          <Trait key={feat}
            title={t(`${feat}_title`)}
            icon={t(`${feat}_icon`)}>
            { t(`${feat}_description`) }
          </Trait>
        )
      }</Traits>
    </HowItWork>
  </Page>
)



// WEBPACK FOOTER //
// ./src/pages/Gifts.js